// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1myiF","row":"Node_row__P7g9d","label":"Node_label__1TYW8","footer":"Node_footer__2dJaJ"};